/*
 * Copyright (c) 2026 Cozy Intellect Inc.
 * File Path: apps/web/src/lib/auth.client.ts
 */

import { createAuthClient } from 'better-auth/svelte';
import { adminClient, inferAdditionalFields } from 'better-auth/client/plugins';
import { oauthProviderClient } from '@better-auth/oauth-provider/client';
import type { auth } from './auth.better-auth';

export const authClient = createAuthClient({
	baseURL: typeof window !== 'undefined' ? `${window.location.origin}/auth` : 'http://localhost:3000/auth',
	plugins: [
		inferAdditionalFields<typeof auth>(),
		oauthProviderClient(), // OAuth Provider client for consent flow
		adminClient()
	]
});
